import React from 'react'
// libs
import styled from 'styled-components'
// hooks
import { useShowModal } from 'hooks/useShowModal'
import { useCurrentUser } from 'hooks/useCurrentUser'
import { useNetworkStatus } from 'hooks/useNetworkStatus'
// constants
import { Modals } from 'constants/modals'
// context
import { RiskAPIContext } from 'containers/Risks/Risk/Edit/layers/API'
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'
// types
import { IRisk } from 'types/graphql'

const Label = styled.div<{ $clickable: boolean }>`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
`

interface Props {
  parentRisk?: IRisk
}

const RiskLabel: React.FC<Props> = ({ parentRisk }) => {
  const onLine = useNetworkStatus()

  const {
    permissionsFromSecurityGroups: { manageRiskTemplates }
  } = useCurrentUser()

  const { risk } = React.useContext(RiskAPIContext)
  const { riskTemplate } = React.useContext(RiskTemplateAPIContext)

  const { showModal } = useShowModal({ modalType: Modals.RISK_EDIT_PREFIX_MODAL })

  const pageLabel = parentRisk
    ? `${parentRisk.riskTemplate.name} \u{0276F} ${riskTemplate.name || 'Unavailable'}`
    : riskTemplate.name

  const prefix = riskTemplate.customerUniqueIdPrefix
  const postfix = risk.customerUniqueIdPostfix

  const riskLabel = prefix ? `${prefix}${postfix} - ${pageLabel}` : pageLabel

  const canEdit = manageRiskTemplates && !!postfix

  const onLabelClick = () => {
    if (canEdit) {
      showModal({ postfix })
    }
  }

  return (
    <Label $clickable={canEdit} onClick={onLabelClick}>
      {onLine ? riskLabel : riskTemplate.name}
    </Label>
  )
}

export default RiskLabel
